import { render } from "./QuestionIcon.vue?vue&type=template&id=4321462f"
import script from "./QuestionIcon.vue?vue&type=script&lang=js"
export * from "./QuestionIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/QuestionIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4321462f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4321462f', __exports__)) {
    api.reload('4321462f', __exports__)
  }
  
  module.hot.accept("./QuestionIcon.vue?vue&type=template&id=4321462f", () => {
    api.rerender('4321462f', render)
  })

}


export default __exports__